var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.254 15.2381V21.2619L20.1905 29.1984L26.2143 23.1746L18.2778 15.2381H12.254ZM15.4286 20C16.3052 20 17.0159 19.2893 17.0159 18.4127C17.0159 17.5361 16.3052 16.8254 15.4286 16.8254C14.5519 16.8254 13.8413 17.5361 13.8413 18.4127C13.8413 19.2893 14.5519 20 15.4286 20Z",
    fill: "#38AEC2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95429 31.0457 0 20 0C8.9543 0 0 8.95429 0 20C0 31.0457 8.9543 40 20 40ZM20.9841 9.35715L29.4841 17.8492C29.5585 17.923 29.6175 18.0108 29.6579 18.1075C29.6981 18.2042 29.7189 18.3079 29.7189 18.4127C29.7189 18.5175 29.6981 18.6212 29.6579 18.7179C29.6175 18.8146 29.5585 18.9024 29.4841 18.9762L27.8968 20.5635L26.7698 19.4365L27.8016 18.4127L19.8651 10.4762H13.8413V12.0635H12.254V10.4762C12.254 10.0552 12.4212 9.65148 12.7189 9.35379C13.0165 9.05613 13.4203 8.88889 13.8413 8.88889H19.8651C20.2854 8.89065 20.6878 9.05906 20.9841 9.35715ZM20.1905 31.1111C20.086 31.1117 19.9825 31.0917 19.8858 31.0522C19.7891 31.0127 19.7011 30.9545 19.627 30.8809L11.1349 22.3809C10.8368 22.0846 10.6684 21.6822 10.6667 21.2619V15.2381C10.6667 14.8171 10.8339 14.4134 11.1316 14.1157C11.4293 13.818 11.833 13.6508 12.254 13.6508H18.2778C18.6981 13.6526 19.1005 13.821 19.3968 14.119L27.8968 22.6111C27.9712 22.6849 28.0302 22.7727 28.0705 22.8694C28.1108 22.9661 28.1316 23.0698 28.1316 23.1746C28.1316 23.2794 28.1108 23.3831 28.0705 23.4798C28.0302 23.5765 27.9712 23.6643 27.8968 23.7381L20.754 30.8809C20.6798 30.9545 20.5919 31.0127 20.4952 31.0522C20.3985 31.0917 20.2949 31.1117 20.1905 31.1111Z",
    fill: "#38AEC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.cecd738cc2420636376bb6dda30b9ca2.svg";
export { ForwardRef as ReactComponent };